import { DistributionChannelResponse } from '../../../integrated-client/models/DistributionChannelResponse';

export interface IDistributionChannelV2EditorData {
  distributionChannels?: Array<DistributionChannelResponse>;
}
export class DistributionChannelV2EditorData implements IDistributionChannelV2EditorData {
  distributionChannels?: Array<DistributionChannelResponse>;
}
